// 设置隐藏div获取dpi
const tempDiv = document.createElement("div");
tempDiv.style.width = '1mm';
tempDiv.style.visibility = 'hidden';
tempDiv.id = 'tempDiv';
document.body.appendChild(tempDiv);
const ration = document.getElementById('tempDiv').getBoundingClientRect().width;
tempDiv.parentNode.removeChild(tempDiv);

export default {
    pxToMm(px) {
        return Math.round(px / ration);
    },
    mmToPx(mm) {
        return Math.round(mm * ration);
    }
}